// React Router is mounted with basename '/bunnings' outside production
// (src/app/bunnings.js), so a client-side `to="/install"` already resolves per
// environment. Anything that builds a real href or sets window.location has to
// apply the same rule itself — hardcoding '/install' works in production and
// breaks everywhere else.
//
// Guarded because this is called during render and socium server-renders
// (src/server/ssr-middleware.js): there is no `window` on the server, and an
// unguarded read would 500 the page. The fallback is exact rather than a
// best guess — SSR injects `window.env = process.env.NODE_ENV`, so both
// branches read the same value and the markup matches after hydration.
const installPath = () => {
  const env = typeof window !== 'undefined' ? window.env : process.env.NODE_ENV;
  return env === 'production' ? '/install' : '/bunnings/install';
};

export default installPath;
